<template>
  <div>
    <!-- <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">To</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control is-expanded">
            <vue-input-tag :tags.sync="innerEmailer.toEmails"
              @new-tag="newEmailInput"
              validate="email"
              tabindex="1" />
            <span class="help is-danger"
              v-if="!isValidToEmail">Invalid email address</span>
            <span class="help is-info"
              v-if="showToHint">Press &lt;Enter&gt; key to add email address</span>
          </div>
        </div>
        <div class="control">
          <button class="button"
            @click="toggleCcBcc"
            tabindex="-1">
            <span class="icon is-small is-left">
              <i class="mdi mdi-24px"
                :class="[ showCcBcc ? 'mdi-chevron-up' : 'mdi-chevron-down' ]" />
            </span>
          </button>
        </div>
      </div>
    </div> -->
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">To</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control is-expanded">
            <multiselect id="toemails-multiselect"
              v-model="selectedToEmails"
              :options="availableToEmails"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="true"
              :preserve-search="true"
              :taggable="true"
              placeholder="Enter email address or search"
              tag-placeholder="Press enter to add email"
              label="email"
              track-by="email"
              :show-labels="false"
              @tag="addEmailTag"
              @search-change="getAssetsEmailAddresses"
              :searchable="true"
              :internal-search="false">
              <template slot="option"
                slot-scope="props">
                <div v-if="props.option.$isLabel"
                  class="recipient-group-header">
                  {{ props.option.groupLabel }}
                </div>
                <div v-else>
                  <span class="tag is-pulled-right"
                    :class="{'is-success' : props.option.assetTypeName === 'Customer', 'is-info' : props.option.assetTypeName === 'Insurer', 'recipient-recent-tag' : props.option.assetTypeName === 'Recent'}">
                    {{ props.option.assetTypeName }}
                  </span>
                  <div v-if="props.option.name && props.option.name !== props.option.email">{{ props.option.name }} &lt;{{ props.option.email }}&gt;</div>
                  <div v-else>{{ props.option.email }}</div>
                  <div class="recipient-subtitle"
                    v-if="props.option.assetTypeName === 'Recent'">{{ recentSentLabel(props.option) }}</div>
                  <div class="recipient-subtitle"
                    v-else-if="props.option.sort === 0 && quoteContactSubtitle(props.option)">{{ quoteContactSubtitle(props.option) }}</div>
                </div>
              </template>
              <template slot="tag"
                slot-scope="props">
                <span class="tag is-primary multiselect-email-tag">
                  {{ props.option.email }}
                  <button class="delete is-small"
                    @click="props.remove(props.option)" />
                </span>
              </template>
            </multiselect>
            <!-- <pre class="language-json"><code>{{ selectedToEmails }}</code></pre> -->
            <span class="help is-danger"
              v-if="!isValidToEmail">Invalid email address</span>
            <span class="help is-info"
              v-if="showToHint">Press &lt;Enter&gt; key to add email address</span>
          </div>
        </div>
        <div class="control">
          <button class="button"
            @click="toggleCc"
            tabindex="-1">
            <span class="icon is-small is-left">
              <i class="mdi mdi-24px"
                :class="[ showCc ? 'mdi-chevron-up' : 'mdi-chevron-down' ]" />
            </span>
            <span>Cc</span>
          </button>
          <button class="button"
            @click="toggleBcc"
            tabindex="-1"
            style="margin-left: 0.5em;">
            <span class="icon is-small is-left">
              <i class="mdi mdi-24px"
                :class="[ showBcc ? 'mdi-chevron-up' : 'mdi-chevron-down' ]" />
            </span>
            <span>Bcc</span>
          </button>
        </div>
      </div>
    </div>
    <div v-show="showCc"
      class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Cc</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control is-expanded">
            <!-- <vue-input-tag :tags.sync="innerEmailer.ccEmails"
              @new-tag="newCcEmailInput"
              validate="email" /> -->
            <multiselect id="ccemails-multiselect"
              v-model="selectedCcEmails"
              :options="availableCcEmails"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="true"
              :preserve-search="true"
              :taggable="true"
              placeholder="Enter email address or search"
              tag-placeholder="Press enter to add email"
              label="email"
              track-by="email"
              :show-labels="false"
              @tag="addEmailTag"
              @search-change="getAssetsEmailAddresses"
              :searchable="true"
              :internal-search="false">
              <template slot="option"
                slot-scope="props">
                <div v-if="props.option.$isLabel"
                  class="recipient-group-header">
                  {{ props.option.groupLabel }}
                </div>
                <div v-else>
                  <span class="tag is-pulled-right"
                    :class="{'is-success' : props.option.assetTypeName === 'Customer', 'is-info' : props.option.assetTypeName === 'Insurer', 'recipient-recent-tag' : props.option.assetTypeName === 'Recent'}">
                    {{ props.option.assetTypeName }}
                  </span>
                  <div v-if="props.option.name && props.option.name !== props.option.email">{{ props.option.name }} &lt;{{ props.option.email }}&gt;</div>
                  <div v-else>{{ props.option.email }}</div>
                  <div class="recipient-subtitle"
                    v-if="props.option.assetTypeName === 'Recent'">{{ recentSentLabel(props.option) }}</div>
                  <div class="recipient-subtitle"
                    v-else-if="props.option.sort === 0 && quoteContactSubtitle(props.option)">{{ quoteContactSubtitle(props.option) }}</div>
                </div>
              </template>
              <template slot="tag"
                slot-scope="props">
                <span class="tag is-primary multiselect-email-tag">
                  {{ props.option.email }}
                  <button class="delete is-small"
                    @click="props.remove(props.option)" />
                </span>
              </template>
            </multiselect>
            <!-- <span class="help is-danger"
              v-if="!isValidCcEmail">Invalid email address</span>
            <span class="help is-info"
              v-if="showCcHint">Press &lt;Enter&gt; key to add email address</span> -->

          </div>
        </div>
      </div>
    </div>
    <div v-show="showBcc"
      class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Bcc</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control is-expanded">
            <!-- <vue-input-tag :tags.sync="innerEmailer.bccEmails"
              @new-tag="newBccEmailInput"
              validate="email" /> -->
            <multiselect id="bccemails-multiselect"
              v-model="selectedBccEmails"
              :options="availableBccEmails"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="true"
              :preserve-search="true"
              :taggable="true"
              placeholder="Enter email address or search"
              tag-placeholder="Press enter to add email"
              label="email"
              track-by="email"
              :show-labels="false"
              @tag="addEmailTag"
              @search-change="getAssetsEmailAddresses"
              :searchable="true"
              :internal-search="false">
              <template slot="option"
                slot-scope="props">
                <div v-if="props.option.$isLabel"
                  class="recipient-group-header">
                  {{ props.option.groupLabel }}
                </div>
                <div v-else>
                  <span class="tag is-pulled-right"
                    :class="{'is-success' : props.option.assetTypeName === 'Customer', 'is-info' : props.option.assetTypeName === 'Insurer', 'recipient-recent-tag' : props.option.assetTypeName === 'Recent'}">
                    {{ props.option.assetTypeName }}
                  </span>
                  <div v-if="props.option.name && props.option.name !== props.option.email">{{ props.option.name }} &lt;{{ props.option.email }}&gt;</div>
                  <div v-else>{{ props.option.email }}</div>
                  <div class="recipient-subtitle"
                    v-if="props.option.assetTypeName === 'Recent'">{{ recentSentLabel(props.option) }}</div>
                  <div class="recipient-subtitle"
                    v-else-if="props.option.sort === 0 && quoteContactSubtitle(props.option)">{{ quoteContactSubtitle(props.option) }}</div>
                </div>
              </template>
              <template slot="tag"
                slot-scope="props">
                <span class="tag is-primary multiselect-email-tag">
                  {{ props.option.email }}
                  <button class="delete is-small"
                    @click="props.remove(props.option)" />
                </span>
              </template>
            </multiselect>
            <span class="help is-danger"
              v-if="!isValidBccEmail">Invalid email address</span>
            <span class="help is-info"
              v-if="showBccHint">Press &lt;Enter&gt; key to add email address</span>
          </div>
        </div>
      </div>
    </div>
    <div v-show="showCc || showBcc"
      class="is-divider" />
    <div v-show="false"
      class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">From</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control is-expanded">
            <input type="text"
              class="input"
              placeholder="">
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Reply To</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control is-expanded">
            <input v-model="replyToMessageId"
              type="text"
              class="input"
              placeholder=""
              readonly>
          </div>
        </div>
      </div>
    </div> -->
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Subject</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control is-expanded">
            <input v-model="innerEmailer.subject"
              type="text"
              class="input"
              placeholder="Subject">
          </div>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Message</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control is-expanded">
            <textarea v-model="innerEmailer.message"
              class="textarea"
              rows="10"
              placeholder="" />
          </div>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Attachments</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control is-expanded">
            <vue-input-tag :tags="combinedAttachments"
              @remove-tag="handleRemovedTag"
              tag-colour="is-turquoise"
              :allow-input="false">
              <template #tag="{ tag }">
                <span>{{ tag.fileName }}</span>
                <span v-if="tag.fileSize > 0"
                  class="ml-1 is-size-7 has-text-grey">
                  ({{ formatFileSize(tag.fileSize) }})
                </span>
              </template>
            </vue-input-tag>
            <div v-if="combinedAttachments.length > 0"
              class="mt-2">
              <!-- File count and size info -->
              <div class="level is-mobile mb-1">
                <div class="level-left">
                  <div class="level-item">
                    <span class="has-text-grey is-size-7">
                      {{ combinedAttachments.length }} files - {{ formatFileSize(totalAttachmentSize) }} total
                    </span>
                  </div>
                </div>
                <div class="level-right">
                  <div class="level-item">
                    <span class="has-text-grey is-size-7">
                      {{ formatFileSize(totalAttachmentSize) }} / {{ maxAttachmentSizeText }}
                    </span>
                  </div>
                </div>
              </div>

              <!-- Progress bar -->
              <div class="progress-container mb-2">
                <progress class="progress is-small"
                  :class="{ 'is-danger': isAttachmentSizeExceeded, '': !isAttachmentSizeExceeded }"
                  :value="totalAttachmentSize"
                  :max="maxTotalAttachmentBytes">
                  {{ attachmentSizePercent }}%
                </progress>
              </div>

              <!-- Warning message -->
              <div v-if="isAttachmentSizeExceeded"
                class="attachment-warning">
                <span class="icon is-large mr-1">
                  <i class="mdi mdi-alert mdi-24px" />
                </span>
                <span>Total attachment size ({{ formatFileSize(totalAttachmentSize) }}) exceeds the {{ maxAttachmentSizeText }} limit.<br>
                  Please remove some files.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FocusInserted } from '@/components/directives'
import VueInputTag from '@/components/VueInputTag'
import EmailService from './EmailService'
import { buildRecipientOptions } from './recentRecipients'
import { timeAgo } from '@/utils/DateFunctions'
import Multiselect from 'vue-multiselect'
import _debounce from 'lodash.debounce'
import { AssetTypes } from '@/enums'
// import _isEmpty from 'lodash/isEmpty'
import _cloneDeep from 'lodash/cloneDeep'
import QuoteService from '@/views/quote/QuoteService'
import { getMaxTotalAttachmentBytes, FALLBACK_MAX_TOTAL_BYTES } from '@/services/emailLimits'
import { buildAttachmentList, sumAttachmentSize } from './attachmentSizes'

/* eslint-disable */
const emailValidator = new RegExp(
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
)
/* eslint-enable */

export default {
  name: 'VueEmail',
  directives: {
    FocusInserted
  },
  components: {
    VueInputTag,
    Multiselect
  },
  props: {
    value: null,
    toEmails: {
      type: Array,
      default: () => []
    },
    ccEmails: {
      type: Array,
      default: () => []
    },
    bccEmails: {
      type: Array,
      default: () => []
    },
    subject: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    attachments: {
      type: Array,
      default: () => []
    },
    reportBytes: {
      type: ArrayBuffer,
      default: null
    },
    reportName: {
      type: String,
      default: ''
    },
    reportContentType: {
      type: String,
      default: ''
    },
    quoteImageAttachments: {
      type: Array,
      default: function () {
        return []
      }
    },
    quoteAttachments: {
      type: Array,
      default: function () {
        return []
      }
    },
    assetId: {
      type: String,
      default: ''
    },
    assetType: {
      type: String,
      default: ''
    },
    replyToMessageId: {
      type: String,
      default: ''
    },
    isShowCc: {
      type: Boolean,
      default: false
    },
    isShowBcc: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      innerEmailer: null,
      showCc: false,
      showBcc: false,
      isValidToEmail: true,
      showToHint: false,
      isValidCcEmail: true,
      showCcHint: false,
      isValidBccEmail: true,
      showBccHint: false,
      innerAttachments: [],
      selectedToEmails: [],
      selectedCcEmails: [],
      selectedBccEmails: [],
      emailFilter: {
        assetId: this.assetId,
        search: '',
        assetTypes: [AssetTypes.Customer, AssetTypes.Insurer],
        pageIndex: 1,
        pageSize: 20
      },
      availableToEmails: [],
      availableCcEmails: [],
      availableBccEmails: [],
      // recent previously-sent addresses (whole shop), fetched once on open.
      recentRecipients: [],
      //attachmentsTag: []
      errors: [],
      // PCK-213 - replaced by the API value in created(). Seeded with the fallback so the meter
      // and the Send gate have a sane limit during the fetch rather than 0 or undefined.
      maxTotalAttachmentBytes: FALLBACK_MAX_TOTAL_BYTES
    }
  },
  computed: {
    attachmentList() {
      return buildAttachmentList(this.innerEmailer, {
        reportName: this.reportName,
        reportBytes: this.reportBytes
      })
    },
    totalAttachmentSize() {
      return sumAttachmentSize(this.attachmentList)
    },
    isAttachmentSizeExceeded() {
      return this.totalAttachmentSize > this.maxTotalAttachmentBytes
    },
    maxAttachmentSizeText() {
      return this.formatFileSize(this.maxTotalAttachmentBytes)
    },
    attachmentSizePercent() {
      if (!this.maxTotalAttachmentBytes) {
        return 0
      }
      return Math.round((this.totalAttachmentSize / this.maxTotalAttachmentBytes) * 100)
    },
    attachmentSizeMessage() {
      if (this.isAttachmentSizeExceeded) {
        return `Total attachment size (${this.formatFileSize(this.totalAttachmentSize)}) exceeds the ${
          this.maxAttachmentSizeText
        } limit. Please remove some attachments to send the email.`
      }
      return `Total attachment size: ${this.formatFileSize(this.totalAttachmentSize)}`
    },
    canSendEmail() {
      const hasToEmails = this.selectedToEmails && this.selectedToEmails.length > 0
      const withinSizeLimit = !this.isAttachmentSizeExceeded
      return hasToEmails && withinSizeLimit
    },
    /**
     * PCK-213 - the quote attachments/images to post IDs for.
     *
     * innerEmailer is the store of record: handleRemovedTag splices removals out of it, and the
     * chips and the running total both read it. The quoteAttachments/quoteImageAttachments props
     * are the parent's scratch copy for the attachment picker - rebuilt from the emailer in
     * attachDocs()/closeDocModal(), committed back in confirmDocSelection(). Nothing refreshes
     * that copy when a chip is removed, so posting IDs from it sent files the user had already
     * deleted: remove 2 of 5 and Send, and the server still fetched all 5 (12MB shown, 20MB sent).
     * Opening the picker appeared to fix it only because attachDocs() re-derives the copy.
     *
     * Fall back to the prop when the emailer does not carry the list at all. Emailer
     * (classes/emails.js) does not define these keys, so QuoteAttachmentCategory - whose selection
     * is a computed over category isSelected flags, never written to the emailer - leaves them
     * undefined, and there the prop is the only selection there is. Callers that do use the
     * emailer always $set an array first, so an emptied list still reads as an array and correctly
     * sends nothing.
     */
    selectedQuoteAttachments() {
      return Array.isArray(this.innerEmailer?.quoteAttachments) ? this.innerEmailer.quoteAttachments : this.quoteAttachments
    },
    selectedQuoteImageAttachments() {
      return Array.isArray(this.innerEmailer?.quoteImageAttachments) ? this.innerEmailer.quoteImageAttachments : this.quoteImageAttachments
    },
    combinedAttachments() {
      return this.attachmentList
    }
  },
  watch: {
    innerEmailer: {
      handler: function (newVal, oldVal) {
        this.$emit('input', newVal)
        // Show Cc if there are any ccEmails
        if (newVal && Array.isArray(newVal.ccEmails)) {
          this.showCc = newVal.ccEmails.length > 0
        }
        // Show Bcc if there are any bccEmails
        if (newVal && Array.isArray(newVal.bccEmails)) {
          this.showBcc = newVal.bccEmails.length > 0
        }
      },
      deep: true
    },
    selectedToEmails: {
      handler: function (newVal, oldVal) {
        if (this.stripHeaderMarkers(this.selectedToEmails)) return
        this.innerEmailer.toEmails.splice(0, this.innerEmailer.toEmails.length)
        this.innerEmailer.toEmails = this.selectedToEmails.map((e) => e.email)
      },
      deep: true
    },
    selectedCcEmails: {
      handler: function (newVal, oldVal) {
        if (this.stripHeaderMarkers(this.selectedCcEmails)) return
        this.innerEmailer.ccEmails.splice(0, this.innerEmailer.ccEmails.length)
        this.innerEmailer.ccEmails = this.selectedCcEmails.map((e) => e.email)
      },
      deep: true
    },
    selectedBccEmails: {
      handler: function (newVal, oldVal) {
        if (this.stripHeaderMarkers(this.selectedBccEmails)) return
        this.innerEmailer.bccEmails.splice(0, this.innerEmailer.bccEmails.length)
        this.innerEmailer.bccEmails = this.selectedBccEmails.map((e) => e.email)
      },
      deep: true
    },
    value: {
      handler: function (newVal, oldVal) {
        this.innerEmailer = newVal
      }
    },
    toEmails: {
      handler: function (newVal, oldVal) {
        if (oldVal && oldVal.length) {
          oldVal.forEach((email) => {
            const index = this.selectedToEmails.findIndex((i) => i.email === email)
            if (index !== -1) this.selectedToEmails.splice(index, 1)
          })
        }
        if (newVal && newVal.length) {
          newVal.forEach((email) => {
            const index = this.selectedToEmails.findIndex((i) => i.email === email)
            if (index === -1) this.selectedToEmails.push({ name: email, email: email })
          })
        }
      }
    },
    ccEmails: {
      handler: function (newVal, oldVal) {
        if (oldVal && oldVal.length) {
          oldVal.forEach((email) => {
            const index = this.selectedCcEmails.findIndex((i) => i.email === email)
            if (index !== -1) this.selectedCcEmails.splice(index, 1)
          })
        }
        if (newVal && newVal.length) {
          newVal.forEach((email) => {
            const index = this.selectedCcEmails.findIndex((i) => i.email === email)
            if (index === -1) this.selectedCcEmails.push({ name: email, email: email })
          })
        }
      }
    },
    bccEmails: {
      handler: function (newVal, oldVal) {
        if (oldVal && oldVal.length) {
          oldVal.forEach((email) => {
            const index = this.selectedBccEmails.findIndex((i) => i.email === email)
            if (index !== -1) this.selectedBccEmails.splice(index, 1)
          })
        }
        if (newVal && newVal.length) {
          newVal.forEach((email) => {
            const index = this.selectedBccEmails.findIndex((i) => i.email === email)
            if (index === -1) this.selectedBccEmails.push({ name: email, email: email })
          })
        }
      }
    },
    message: {
      handler: function (newVal, oldVal) {
        this.innerEmailer.message = newVal
      }
    },
    subject: {
      handler: function (newVal, oldVal) {
        this.innerEmailer.subject = newVal
      }
    },
    isShowCc: {
      handler: function (newVal) {
        this.showCc = newVal
      }
    },
    isShowBcc: {
      handler: function (newVal) {
        this.showBcc = newVal
      }
    },
    canSendEmail: {
      handler: function (newVal) {
        this.$emit('validation-changed', {
          canSend: newVal,
          isAttachmentSizeExceeded: this.isAttachmentSizeExceeded,
          totalSize: this.totalAttachmentSize,
          errors: this.getValidationErrors()
        })
      },
      immediate: true
    }
  },
  created() {
    this.loadMaxAttachmentSize()
    this.innerEmailer = _cloneDeep(this.value)
    this.populateEmails()
    this.emailFilter.assetTypes = this.innerEmailer.assetTypes
    this.refreshAttachmentList()
    this.loadRecentRecipients()
    this.getAssetsEmailAddresses()
    this.showCc = this.isShowCc
    this.showBcc = this.isShowBcc
  },
  mounted() {},
  methods: {
    async loadMaxAttachmentSize() {
      this.maxTotalAttachmentBytes = await getMaxTotalAttachmentBytes()
    },
    populateEmails() {
      if (this.innerEmailer.toEmails) {
        this.innerEmailer.toEmails.forEach((email) =>
          this.selectedToEmails.splice(this.selectedToEmails.length, 1, {
            name: email,
            email: email
          })
        )
      }
      if (this.innerEmailer.ccEmails) {
        this.innerEmailer.ccEmails.forEach((email) =>
          this.selectedCcEmails.splice(this.selectedCcEmails.length, 1, {
            name: email,
            email: email
          })
        )
      }
      if (this.innerEmailer.bccEmails) {
        this.innerEmailer.bccEmails.forEach((email) =>
          this.selectedBccEmails.splice(this.selectedBccEmails.length, 1, {
            name: email,
            email: email
          })
        )
      }
    },
    toggleCc() {
      this.showCc = !this.showCc
    },
    toggleBcc() {
      this.showBcc = !this.showBcc
    },
    // toggleCcBcc() {
    //   this.showCcBcc = !this.showCcBcc
    // },
    getValidationErrors() {
      const errors = []
      if (!this.selectedToEmails || !this.selectedToEmails.length) {
        errors.push('Email address "To" is not provided.')
      }
      if (this.isAttachmentSizeExceeded) {
        errors.push(
          `Total attachment size (${this.formatFileSize(this.totalAttachmentSize)}) exceeds the ${this.maxAttachmentSizeText} limit.`
        )
      }
      return errors
    },
    isValid() {
      this.errors = this.getValidationErrors()
      return this.errors.length === 0
    },
    async send() {
      const isValid = this.isValid()
      if (!isValid) {
        this.$notification.error('Email', this.errors.join(' '))
        return
      }
      this.$showSpinner('Sending...')
      try {

        const formData = new FormData()
        const blob = new Blob([this.reportBytes], { type: this.reportContentType })
        if (this.innerEmailer.attachments.indexOf(this.reportName) > -1) {
          formData.append('report', blob, this.reportName)
        }
        // Add custom attachments as files
        if (Array.isArray(this.innerEmailer.customAttachments)) {
          for (const att of this.innerEmailer.customAttachments) {
            if (att && att.fileBytes && att.fileName) {
              const fileBlob = new Blob([att.fileBytes], { type: att.fileType || 'application/octet-stream' })
              formData.append('customAttachment', fileBlob, att.fileName)
            }
          }
        }
        this.innerEmailer.replyToMessageId = this.replyToMessageId
        formData.append('emailer', JSON.stringify(this.innerEmailer))
        formData.append('imageIds', JSON.stringify(this.selectedQuoteImageAttachments.map((i) => i.quoteImageId)))
        formData.append('quoteAttachmentIds', JSON.stringify(this.selectedQuoteAttachments.map((i) => i.quoteAttachmentId)))
        await EmailService.send(formData)
        this.$notification.openNotificationWithType('success', 'Send Email', 'Email sent successfully')
        this.$emit('sent')
        this.reset()
      } catch (e) {
        this.$notification.openMessageXhrError('Send Email', e)
      } finally {
        this.$hideSpinner()
      }
    },
    async sendExport(exportOptions, reportOptions, assessment = null) {
      this.$showSpinner('Sending...')
      try {
        const formData = new FormData()
        const blob = new Blob([this.reportBytes], { type: this.reportContentType })
        if (this.innerEmailer.attachments.indexOf(this.reportName) > -1) {
          formData.append('report', blob, this.reportName)
        }
        formData.append('emailer', JSON.stringify(this.innerEmailer))
        // formData.append('images', JSON.stringify(this.quoteImageAttachments))
        formData.append('imageIds', JSON.stringify(this.selectedQuoteImageAttachments.map((i) => i.quoteImageId)))
        if (assessment) {
          await QuoteService.requestAuthorityAssessment(this.innerEmailer.assetId, assessment)
        }
        await EmailService.sendExport(this.innerEmailer.assetId, exportOptions, reportOptions, formData)
        this.$notification.openNotificationWithType('success', 'Send Email', 'Email sent successfully')
        this.$emit('sent')
      } catch (e) {
        this.$notification.openMessageXhrError('Send Email', e)
      } finally {
        this.$hideSpinner()
      }
    },
    newEmailInput(newEmail) {
      this.isValidToEmail = newEmail === '' || emailValidator.test(newEmail)
      this.showToHint = this.isValidToEmail && newEmail !== ''
      this.$emit('new-email', newEmail !== '')
    },
    newCcEmailInput(newEmail) {
      this.isValidCcEmail = newEmail === '' || emailValidator.test(newEmail)
      this.showCcHint = this.isValidCcEmail && newEmail !== ''
      this.$emit('new-email', newEmail !== '')
    },
    newBccEmailInput(newEmail) {
      this.isValidBccEmail = newEmail === '' || emailValidator.test(newEmail)
      this.showBccHint = this.isValidBccEmail && newEmail !== ''
      this.$emit('new-email', newEmail !== '')
    },
    refreshAttachmentList(images) {
      // this.innerEmailer.attachments.splice(0, this.innerEmailer.attachments.length)
      // this.innerEmailer.attachments.splice(this.innerEmailer.attachments.length, 1, this.reportName)
      // // console.log(images)
      // if (!_isEmpty(images)) {
      //   for (var i = 0; i < images.length; i++) {
      //     this.innerEmailer.attachments.splice(this.innerEmailer.attachments.length, 1, images[i].fileName)
      //   }
      // }
    },
    addEmailTag(newEmail, id) {
      const isValidEmail = emailValidator.test(newEmail)
      // console.log('newTag', this.isValidToEmail, newEmail)
      if (isValidEmail) {
        const tag = {
          name: newEmail,
          email: newEmail,
          assetTypeName: 'None',
          assetType: 0
        }
        if (id === 'toemails-multiselect') {
          this.isValidToEmail = isValidEmail
          this.availableToEmails.push(tag)
          this.selectedToEmails.push(tag)
        } else if (id === 'ccemails-multiselect') {
          this.isValidCcEmail = isValidEmail
          this.availableCcEmails.push(tag)
          this.selectedCcEmails.push(tag)
        } else if (id === 'bccemails-multiselect') {
          this.isValidBccEmail = isValidEmail
          this.availableBccEmails.push(tag)
          this.selectedBccEmails.push(tag)
        }
      }
    },
    // load the recent-recipients pool once; re-merge the To options if
    // contacts were already fetched before this resolved.
    async loadRecentRecipients() {
      try {
        this.recentRecipients = (await EmailService.getRecentRecipients()) || []
      } catch {
        this.recentRecipients = []
      }
      if (this.recentRecipients.length) {
        this.getAssetsEmailAddresses()
      }
    },
    stripHeaderMarkers(selected) {
      const index = selected.findIndex((e) => e && e.$isLabel)
      if (index !== -1) {
        selected.splice(index, 1)
        return true
      }
      return false
    },
    quoteContactSubtitle(option) {
      if (!option) return ''
      if (option.assetTypeName === 'Customer') return 'this quote\'s customer'
      if (option.assetTypeName === 'Insurer') return 'matched work provider'
      return ''
    },
    recentSentLabel(option) {
      if (!option) return ''
      const when = timeAgo(option.lastSentOn)
      const times = option.count > 0 ? ` · ${option.count} ${option.count === 1 ? 'time' : 'times'}` : ''
      return when ? `Sent ${when}${times}` : ''
    },
    getAssetsEmailAddresses: _debounce(async function (query, id) {
      // console.log('getAssetsEmailAddresses', query, id)
      if (!this.$guid.validGuid(this.emailFilter.assetId)) {
        this.emailFilter.assetId = this.$guid.empty()
      }
      this.emailFilter.search = query || ''
      if (id === 'toemails-multiselect' || !id) {
        const contacts = await EmailService.getAssetsEmailAddresses(this.emailFilter)
        this.availableToEmails = buildRecipientOptions(contacts, this.recentRecipients, this.emailFilter.search)
      } else if (id === 'ccemails-multiselect') {
        const contacts = await EmailService.getAssetsEmailAddresses(this.emailFilter)
        this.availableCcEmails = buildRecipientOptions(contacts, this.recentRecipients, this.emailFilter.search)
      } else if (id === 'bccemails-multiselect') {
        const contacts = await EmailService.getAssetsEmailAddresses(this.emailFilter)
        this.availableBccEmails = buildRecipientOptions(contacts, this.recentRecipients, this.emailFilter.search)
      }
    }, 300),
    reset() {
      this.selectedToEmails.splice(0, this.selectedToEmails.length)
      this.selectedCcEmails.splice(0, this.selectedCcEmails.length)
      this.selectedBccEmails.splice(0, this.selectedBccEmails.length)
    },
    handleRemovedTag({ tag }) {
      // Clone the current emailer to avoid direct mutations
      const updatedEmailer = _cloneDeep(this.innerEmailer)

      // Extract the filename from the tag object
      const tagName = tag.fileName || tag

      // Remove from customAttachments if present
      if (updatedEmailer.customAttachments) {
        const customIndex = updatedEmailer.customAttachments.findIndex((att) => att && att.fileName && att.fileName.toLowerCase() === tagName.toLowerCase())
        if (customIndex !== -1) {
          updatedEmailer.customAttachments.splice(customIndex, 1)
        }
      }

      // Enhanced removal from quoteAttachments
      if (updatedEmailer.quoteAttachments) {
        // Find by multiple possible filename properties and case-insensitive comparison
        const quoteIndex = updatedEmailer.quoteAttachments.findIndex((att) => {
          if (!att) return false
          const attName = att.fileName || att.filename || att.name
          return attName && attName.toLowerCase() === tagName.toLowerCase()
        })

        if (quoteIndex !== -1) {
          // // Store the removed attachment details for potential undo
          // const removedAttachment = updatedEmailer.quoteAttachments[quoteIndex]
          // Remove the attachment
          updatedEmailer.quoteAttachments.splice(quoteIndex, 1)

          // Also remove from attachments array if present
          if (updatedEmailer.attachments) {
            const attachIndex = updatedEmailer.attachments.findIndex((att) => {
              if (typeof att === 'string') {
                return att.toLowerCase() === tagName.toLowerCase()
              }
              return att && att.fileName && att.fileName.toLowerCase() === tagName.toLowerCase()
            })
            if (attachIndex !== -1) {
              updatedEmailer.attachments.splice(attachIndex, 1)
            }
          }
        }
      }

      // Remove from regular attachments if present
      if (updatedEmailer.attachments) {
        const attachIndex = updatedEmailer.attachments.findIndex((att) => {
          if (typeof att === 'string') {
            return att.toLowerCase() === tagName.toLowerCase()
          }
          return att && att.fileName && att.fileName.toLowerCase() === tagName.toLowerCase()
        })
        if (attachIndex !== -1) {
          updatedEmailer.attachments.splice(attachIndex, 1)
        }
      }

      //Remove from quoteImageAttachments if present
      if (updatedEmailer.quoteImageAttachments) {
        const imageIndex = updatedEmailer.quoteImageAttachments.findIndex((img) => {
          if (!img) return false
          const imgName = img.fileName || img.filename || img.name
          return imgName && imgName.toLowerCase() === tagName.toLowerCase()
        })
        if (imageIndex !== -1) {
          updatedEmailer.quoteImageAttachments.splice(imageIndex, 1)
        }
      }

      // Update the emailer and emit change event
      this.innerEmailer = updatedEmailer
      //this.$emit('attachments-updated')
    },
    formatFileSize(sizeInBytes) {
      if (!sizeInBytes || sizeInBytes === 0) {
        return '0 KB'
      }

      const units = ['Bytes', 'KB', 'MB', 'GB']
      let size = sizeInBytes
      let unitIndex = 0

      while (size >= 1024 && unitIndex < units.length - 1) {
        size /= 1024
        unitIndex++
      }

      return `${size.toFixed(unitIndex === 0 ? 0 : 1)} ${units[unitIndex]}`
    }
  }
}
</script>

<style lang="scss" scoped>
.is-divider {
  margin: 1.2em 0;
}
.multiselect-email-tag {
  margin-right: 0.5rem;
  text-transform: lowercase !important;
}

.recipient-group-header {
  text-transform: uppercase;
  font-weight: 700;
  font-size: 0.7rem;
  letter-spacing: 0.04em;
  color: #7a7a7a;
  cursor: default;
}
.recipient-subtitle {
  font-size: 0.75rem;
  color: #7a7a7a;
  text-transform: none;
}
.tag.recipient-recent-tag {
  background-color: #f9bf00;
  color: rgba(0, 0, 0, 0.7);
}

.progress-container {
  .progress {
    height: 8px;
    border-radius: 4px;

    &.is-danger::-webkit-progress-bar {
      background-color: #f5f5f5;
    }

    &.is-danger::-webkit-progress-value {
      background-color: #ff3860;
    }

    &.is-danger::-moz-progress-bar {
      background-color: #ff3860;
    }

    &.is-primary::-webkit-progress-value {
      background-color: #00d1b2;
    }

    &.is-primary::-moz-progress-bar {
      background-color: #00d1b2;
    }
  }
}

.attachment-warning {
  // background-color: #f5f5f5;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 8px 12px;
  color: #ff3860;
  font-size: 0.75rem;
  display: flex;
  align-items: center;
}
</style>

<style lang="scss">
#toemails-multiselect,
#ccemails-multiselect,
#bccemails-multiselect {
  text-transform: lowercase !important;
}
</style>
